import React from "react";

const PrivacyPolicy = () => {
  const lastUpdated = "March 29, 2026";

  const styles = {
    outerContainer: {
      backgroundColor: "#f8fafc",
      minHeight: "100vh",
      width: "100%",
      padding: "24px 5%",
      fontFamily:
        '-apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif',
      color: "#0f172a",
      lineHeight: "1.5",
      boxSizing: "border-box",
    },
    contentWrapper: {
      width: "100%",      
      maxWidth: "1400px", 
      margin: "0 auto",
    },
    header: {
      marginBottom: "15px",
      textAlign: "left",
      borderBottom: "1px solid #e2e8f0",
      paddingBottom: "10px",
    },
    title: {
      fontSize: "48px",
      fontWeight: "900",
      letterSpacing: "-0.025em",
      margin: "0 0 16px 0",
    },
    lastUpdatedText: {
      color: "#64748b",
      fontSize: "14px",
      textTransform: "uppercase",
      letterSpacing: "0.1em",
      fontWeight: "500",
    },
    dateHighlight: {
      color: "#2563eb",
    },
    policyCard: {
      backgroundColor: "#ffffff",
      padding: "30px",
      borderRadius: "24px",
      boxShadow:
        "0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06)",
      border: "1px solid #f1f5f9",
      display: "flex",
      flexDirection: "column",
      gap: "20px",
    },
    section: {
      position: "relative",
    },
    headingGroup: {
      display: "flex",
      alignItems: "center",
      marginBottom: "24px",
    },
    accentBar: {
      width: "40px",
      height: "5px",
      backgroundColor: "#2563eb",
      marginRight: "16px",
      borderRadius: "9999px",
    },
    sectionTitle: {
      fontSize: "28px",
      fontWeight: "800",
      margin: "0",
    },
    paragraph: {
      color: "#475569",
      lineHeight: "1.8",
      fontSize: "18px",
      paddingLeft: "56px", 
      margin: "0",
    },
    list: {
      listStyle: "none",
      padding: "0",
      margin: "20px 0 0 0",
      display: "flex",
      flexDirection: "column",
      gap: "16px",
    },
    listItem: {
      display: "flex",
      alignItems: "flex-start",
    },
    arrow: {
      color: "#2563eb",
      marginRight: "12px",
      fontWeight: "bold",
    },
    contactBanner: {
      backgroundColor: "#0f172a",
      borderRadius: "20px",
      padding: "50px",
      color: "#ffffff",
      marginTop: "20px",
    },
    contactTitle: {
      fontSize: "28px",
      fontWeight: "700",
      margin: "0 0 16px 0",
    },
    contactText: {
      color: "#cbd5e1",
      fontSize: "18px",
      lineHeight: "1.6",
      marginBottom: "32px",
      maxWidth: "800px", 
    },
    button: {
      display: "inline-block",
      backgroundColor: "#2563eb",
      color: "#ffffff",
      fontWeight: "700",
      padding: "16px 40px",
      borderRadius: "9999px",
      textDecoration: "none",
    },
    footer: {
      marginTop: "64px",
      textAlign: "center",
      color: "#94a3b8",
      fontSize: "14px",
    },
  };

  return (
    <div style={styles.outerContainer}>
      <div style={styles.contentWrapper}>
        <header style={styles.header}>
          <h1 style={styles.title}>Privacy Policy</h1>
          <p style={styles.lastUpdatedText}>
            Last Updated: <span style={styles.dateHighlight}>{lastUpdated}</span>
          </p>
        </header>

        <div style={styles.policyCard}>
          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>Information We Collect</h2>
            </div>
            <p style={styles.paragraph}>
              We collect information you provide directly to us. This includes
              account creation data, purchase history, and communications. We
              prioritize <strong>data minimization</strong>, ensuring we only store what is
              strictly necessary to provide our services.
            </p>
          </section>

          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>How We Use Your Information</h2>
            </div>
            <div style={styles.paragraph}>
              <p style={{ margin: "0 0 16px 0" }}>
                We use the collected data for the following core purposes:
              </p>
              <ul style={styles.list}>
                <li style={styles.listItem}>
                  <span style={styles.arrow}>→</span>
                  Maintaining and personalizing your user profile.
                </li>
                <li style={styles.listItem}>
                  <span style={styles.arrow}>→</span>
                  Processing transactions securely via encrypted gateways.
                </li>
                <li style={styles.listItem}>
                  <span style={styles.arrow}>→</span>
                  Providing proactive customer support.
                </li>
              </ul>
            </div>
          </section>

          <section style={styles.section}>
            <div style={styles.headingGroup}>
              <span style={styles.accentBar}></span>
              <h2 style={styles.sectionTitle}>Information Sharing</h2>
            </div>
            <p style={styles.paragraph}>
              We do not sell your personal information. We only share data with
              trusted third-party partners (like payment processors) who are
              legally required to maintain strict confidentiality.
            </p>
          </section>

          <section style={styles.contactBanner}>
            <h2 style={styles.contactTitle}>Contact Us</h2>
            <p style={styles.contactText}>
              If you have any questions about this Privacy Policy or how your
              data is handled, please reach out to our privacy officer.
            </p>
            <a
              href="mailto:privacy@yourcompany.com"
              style={styles.button}
            >
              Contact Support
            </a>
          </section>
        </div>

        <footer style={styles.footer}>
          <p>© {new Date().getFullYear()} Your Company Name. All Rights Reserved.</p>
        </footer>
      </div>
    </div>
  );
};

export default PrivacyPolicy;